var _g;
import { jsx as _jsx } from "react/jsx-runtime";
var Amex = function Amex(_ref) {
  var className = _ref.className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    ignoreColor = _ref.ignoreColor;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size * 6,
    height: size,
    viewBox: "0 0 48 8",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    children: /*#__PURE__*/_jsx("g", {
      id: "Page-1",
      stroke: "none",
      strokeWidth: "1",
      fillRule: "evenodd",
      children: /*#__PURE__*/_jsx("g", {
        id: "PC-1366-Copy-11",
        transform: "translate(-1132.000000, -1429.000000)",
        fill: !ignoreColor ? color : undefined,
        children: _g || (_g = /*#__PURE__*/_jsx("g", {
          id: "Group-4",
          transform: "translate(0.000000, 922.000000)",
          children: /*#__PURE__*/_jsx("g", {
            id: "Group-2",
            transform: "translate(1044.000000, 504.000000)",
            children: /*#__PURE__*/_jsx("g", {
              id: "Page-1",
              children: /*#__PURE__*/_jsx("g", {
                id: "Group-15",
                transform: "translate(0.000000, 0.011200)",
                children: /*#__PURE__*/_jsx("path", {
                  d: "M135.998,3 L132.568,3 L130.251,5.568 L127.935,3 L124.505,3 L128.183,6.908 L124.505,10.985 L127.834,10.985 L130.251,8.305 L132.669,10.985 L135.998,10.985 L132.321,6.908 L135.998,3 Z M114.565,10.985 L123.225,10.985 L123.225,9.053 L117.04,9.053 L117.04,7.959 L122.943,7.959 L122.943,6.037 L117.04,6.037 L117.04,4.932 L123.225,4.932 L123.225,3 L114.565,3 L114.565,10.985 Z M107.335,7.489 C107.269,7.635 107.248,8.45 107.149,8.45 C107.052,8.45 107.03,7.635 106.964,7.489 L104.915,3 L100.61,3 L100.61,10.985 L103.008,10.985 L103.008,5.39 C103.008,5.155 102.899,4.909 102.899,4.775 C102.899,4.72 102.91,4.686 102.964,4.686 C103.04,4.686 103.128,4.932 103.182,5.055 L106.169,10.985 L108.13,10.985 L110.899,5.077 C110.953,4.954 111.04,4.709 111.117,4.709 C111.161,4.709 111.182,4.73 111.182,4.775 C111.182,4.943 111.073,5.166 111.073,5.412 L111.073,10.985 L113.471,10.985 L113.471,3 L109.384,3 L107.335,7.489 Z M92.577,7.59 L93.904,4.787 L94.297,4.787 L95.624,7.59 L92.577,7.59 Z M91.992,3 L88,10.985 L90.89,10.985 L91.655,9.656 L96.558,9.656 L97.322,10.985 L100.213,10.985 L96.209,3 L91.992,3 Z",
                  id: "Fill-9"
                })
              })
            })
          })
        }))
      })
    })
  });
};
export default Amex;